__turbopack_context__.v({
  "gradient": "main-banner-list-block-module-scss-module__liZUka__gradient",
});
